module.exports = __webpack_public_path__ + "static/media/logo.cd8265e0.svg";